// Mutation hook - pobranie pliku zalacznika Notify jako blob i wymuszenie downloadu.
// GET /api/ui/sales-crm/notify/{id}/attachments/{attachmentId}/download?download=1
// Sprint 3 v4.1. BinaryFileResponse - axios musi miec responseType: 'blob'.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IUseDownloadNotifyAttachmentParams {
  notifyId: number;
  attachmentId: number;
  filename: string;
  /** true = wymus download (Content-Disposition: attachment). false = inline (np. preview). */
  forceDownload?: boolean;
}

export interface IDownloadNotifyAttachmentResult {
  ok: true;
}

const downloadNotifyAttachment = async (
  params: IUseDownloadNotifyAttachmentParams
): Promise<IDownloadNotifyAttachmentResult> => {
  const blob: Blob = await axios.get(
    `/sales-crm/notify/${params.notifyId}/attachments/${params.attachmentId}/download`,
    {
      params: params.forceDownload === false ? undefined : { download: 1 },
      responseType: 'blob'
    }
  );

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = params.filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { ok: true };
};

export const useDownloadNotifyAttachment = (
  options?: UseMutationOptions<
    IDownloadNotifyAttachmentResult,
    IError,
    IUseDownloadNotifyAttachmentParams
  >
) =>
  useMutation<IDownloadNotifyAttachmentResult, IError, IUseDownloadNotifyAttachmentParams>(
    downloadNotifyAttachment,
    options
  );
